import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor() {}
  toasts = signal<
    {
      message: string;
      duration: number;
      type: 'success' | 'danger' | 'warning';
      timemout: NodeJS.Timeout;
    }[]
  >([]);

  add(
    message: string,
    duration: number = 15000,
    type: 'success' | 'danger' | 'warning' = 'success'
  ) {
    const timemout = setTimeout(() => this.remove(0), duration);
    this.toasts.update((value) => {
      value.push({ message, duration, type, timemout });
      return value;
    });
  }

  remove(index: number) {
    if (this.toasts.length < index) {
      return;
    }
    this.toasts.update((value) => {
      clearTimeout(value[index]?.timemout);
      value.splice(index, 1);
      return value;
    });
  }
}
